import React from 'react';

const PhidgetSvg = ({width = 20, height = 20, couleur = "#002335"}) => (
    <svg width={width} height={height} viewBox="0 0 40 53" fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-inside-1_2893_7490" fill="white">
            <path
                d="M12.4482 14.7738C12.4482 10.5765 15.8509 7.17383 20.0482 7.17383C24.2456 7.17383 27.6482 10.5765 27.6482 14.7738C27.6482 18.9712 24.2456 22.3738 20.0482 22.3738H14.4482C13.3437 22.3738 12.4482 21.4784 12.4482 20.3738V14.7738Z"/>
        </mask>
        <path
            d="M12.4482 14.7738C12.4482 10.5765 15.8509 7.17383 20.0482 7.17383C24.2456 7.17383 27.6482 10.5765 27.6482 14.7738C27.6482 18.9712 24.2456 22.3738 20.0482 22.3738H14.4482C13.3437 22.3738 12.4482 21.4784 12.4482 20.3738V14.7738Z"
            stroke={couleur} strokeWidth="6" mask="url(#path-1-inside-1_2893_7490)"/>
        <path
            d="M14.4482 25.4727H25.6482C25.9244 25.4727 26.1482 25.6965 26.1482 25.9727V37.1727C26.1482 37.4488 25.9244 37.6727 25.6482 37.6727H14.4482C14.1721 37.6727 13.9482 37.4488 13.9482 37.1727V25.9727C13.9482 25.6965 14.1721 25.4727 14.4482 25.4727Z"
            stroke={couleur} strokeWidth="3"/>
        <rect x="4.04785" y="2.77344" width="32" height="47.2" rx="2" stroke={couleur}
              strokeWidth="4"/>
        <circle cx="16.0477" cy="44.3738" r="1.2" fill={couleur}/>
        <circle cx="24.0477" cy="44.3738" r="1.2" fill={couleur}/>
        <circle cx="20.0477" cy="44.3738" r="1.2" fill={couleur}/>
    </svg>
);

export default PhidgetSvg;
